import { render, staticRenderFns } from "./TabList.vue?vue&type=template&id=7b5671e2"
import script from "./TabList.vue?vue&type=script&lang=js"
export * from "./TabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5671e2')) {
      api.createRecord('7b5671e2', component.options)
    } else {
      api.reload('7b5671e2', component.options)
    }
    module.hot.accept("./TabList.vue?vue&type=template&id=7b5671e2", function () {
      api.rerender('7b5671e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaTabs/TabList.vue"
export default component.exports